import { render, staticRenderFns } from "./VaccinationAttributes.vue?vue&type=template&id=5c30454c&scoped=true&"
import script from "./VaccinationAttributes.vue?vue&type=script&lang=js&"
export * from "./VaccinationAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c30454c",
  null
  
)

export default component.exports